import { CondaPlatformSettings, PaymentQRCodeType } from '../typings'

export function getPlatformSettings(): CondaPlatformSettings {
    return window.platformSettings
}

export function getLockableNaturalProfileAttributes(): Array<string> {
    return getPlatformSettings()?.lockable_natural_profile_attributes
}

export function getLockableNaturalProfileRelations(): Array<string> {
    return getPlatformSettings()?.lockable_natural_profile_relations
}

export function getLockableLegalProfileAttributes(): Array<string> {
    return getPlatformSettings()?.lockable_legal_profile_attributes
}

export function getLockableLegalProfileRelations(): Array<string> {
    return getPlatformSettings()?.lockable_legal_profile_relations
}

export function getTermsUrl(): string {
    return getPlatformSettings()?.terms_url
}

export function getPrivacyUrl(): string {
    return getPlatformSettings()?.privacy_url
}

export function getExternalSecurityLink(): string {
    return getPlatformSettings()?.external_security_link
}

export function getAdminEmail(): string {
    return getPlatformSettings()?.admin_email
}

export function getIsIbanFromBankAccount(): boolean {
    return getPlatformSettings()?.is_iban_from_bank_account
}

export function getDisableIbanBicValidation(): boolean {
    return getPlatformSettings()?.disable_iban_bic_validation
}

export function getPaymentQrCodeType(): PaymentQRCodeType {
    return getPlatformSettings()?.payment_qr_code_type
}

export function getPlatformName(): string {
    return getPlatformSettings()?.platform_name
}

export function getCurrency(): string {
    return getPlatformSettings()?.currency
}

export function isCouponCodeEnabled(): boolean {
    return window.condaIsCouponCodeEnabled
}

export function getSelfDisclosureFormUrl(): string {
    return getPlatformSettings()?.self_disclosure_form_url
}

export function isCertificateEnabled(): boolean {
    return getPlatformSettings()?.certificate
}
